import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMSmallStatus } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getStreetlightStatusValue } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { makeGetCardCopy } from "../card-copy";

/** Adds the overall status card (#2222). */
export function addStatusCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const statusCard = view.addComponent({
    component: PMSmallStatus,
    layoutProps: {
      componentId: "statusComponent",
      labels: ["report-status"],
      title: getCardCopy(language, "reportOverallStatus").title,
      description: getCardCopy(language, "reportOverallStatus").description,
    },
  });

  statusCard.mapState(({ currentReport, settings }) => {
    const overallStatus = currentReport?.project?._calculated?.overallStatus;
    const overallSemaphoreStatus =
      currentReport?.project?._calculated?.overallSemaphoreStatus;
    const semaphoreStatus1 =
      currentReport?.project?._calculated?.semaphoreStatus1;
    const semaphoreStatus2 =
      currentReport?.project?._calculated?.semaphoreStatus2;
    const semaphoreStatus3 =
      currentReport?.project?._calculated?.semaphoreStatus3;
    return {
      // The card header reads "Status", not "Gesamtstatus" — same as the
      // program-level status card on the dashboard. The card copy under
      // `reportOverallStatus` stays as it is: it is what the card picker and
      // the info tooltip show.
      title: getLocalizedMessage(language, "status") || "Status",
      primaryStatusIndicatorSize: "large",
      fixedHeight: "134px",
      status:
        settings?.configuration?.statusReportingLevel === "category"
          ? (getStreetlightStatusValue(overallSemaphoreStatus) ?? "")
          : (getStreetlightStatusValue(overallStatus) ?? ""),
      subStatusesDisplay: "column",
      subStatuses:
        settings?.configuration?.statusReportingLevel === "category"
          ? [semaphoreStatus1, semaphoreStatus2, semaphoreStatus3].map(
              (status, index) => ({
                name:
                  settings?.configuration?.semaphoreStatusDefinition?.[index]
                    ?.name ?? "",
                status: getStreetlightStatusValue(status) ?? "",
              })
            )
          : undefined,
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });

  statusCard.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "status", "itemReporting")
  );
}
